import { useMemo } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { can, type PermissionKey } from '../permissions';

/**
 * UI-only permission check. The server still enforces the same rule and returns
 * 403 regardless of what the hook reports — this is purely for gating buttons,
 * tabs, and menu items.
 *
 * @example const { allowed } = usePermission('commitment.delete');
 */
export function usePermission(key: PermissionKey): { allowed: boolean } {
  const { effectiveRole } = useAuth();
  return useMemo(() => ({ allowed: can(effectiveRole, key) }), [effectiveRole, key]);
}
